import { showToast } from 'api/CommonApi';
import { useContentLocalizer } from './useContentLocalizer';
import { ErrorToast } from 'models/knowledgeBase/ErrorToast';
import { localization } from 'views/KnowledgeBase/Documents/localization';

export const useFileErrorHandler = (): {
    handleFileError: (consoleError: string, defaultError: ErrorToast, error: string) => void
} => {
    const translate = useContentLocalizer(localization);

    const handleErrorDescription = (error: string): ErrorToast | null => {
        const lowerCaseError = error?.toLowerCase() || '';

        if (lowerCaseError.includes('unsupported file content-type')) {
            return translate.toastFileErrors.unsupportedFileType;
        }

        if (lowerCaseError.includes('error loading pdf document')) {
            return translate.toastFileErrors.pdfLoadingError;
        }

        if (lowerCaseError.includes('empty file')) {
            return translate.toastFileErrors.emptyFile;
        }

        if (lowerCaseError.includes('file formatting missmatch')) {
            return translate.toastFileErrors.fileFormattingError;
        }

        if (lowerCaseError.includes('missing required column') &&
            lowerCaseError.includes('text')) {
            return translate.toastFileErrors.missingTextColumn;
        }

        if (lowerCaseError.includes('not_found')) {
            return translate.toastUrlErrors.notfound;
        }

        if (lowerCaseError.includes('blocked_site')) {
            return translate.toastUrlErrors.blocked;
        }

        return null;
    };

    const handleFileError = (consoleError: string, defaultError: ErrorToast, error: string) => {
        // eslint-disable-next-line no-console
        console.error(consoleError, ' ', error);

        const specificError = handleErrorDescription(error || '');
        const errorToast = specificError || defaultError;

        showToast({
            title: errorToast.title,
            message: errorToast.message,
            type: 'danger',
        });
    };

    return { handleFileError };
};
